import { put, select, takeLatest } from 'redux-saga/effects';
import { createPanelApiSaga } from '@/features/auth/store/panel-api-saga';
import type { RootState } from '@/shared/store/store';
import * as salesApi from '../api/sales-inquiries.api';
import { isOutcomeUnknown } from '@/features/organizations/model/write-outcome';
import { toSalesQuery } from '../model/sales-query';
import {
  changeSalesInquiryStatus,
  fetchSalesCounts,
  fetchSalesInquiries,
  fetchSalesInquiry,
  fetchSalesInquiryPicker,
} from './sales-inquiries.slice';

const apiSaga = createPanelApiSaga();

function* refreshSalesList() {
  const filters = (yield select(
    (state: RootState) => state.panelSales.filters,
  )) as RootState['panelSales']['filters'];
  yield put(fetchSalesInquiries.request(toSalesQuery(filters)));
}

/**
 * `takeLatest` YARIŞ KAPISIDIR: süzgeç ya da arama değişince önceki liste
 * cevabı yeni listeyi ezemez; personel adaydan adaya hızlı geçerken de eski
 * adayın detayı yenisinin yerine yazılamaz (slice ayrıca kimliği karşılaştırır).
 *
 * Durum değişimi `takeLatest` DEĞİL, düğme kilidiyle tekildir: seçici istek
 * sürerken kapalıdır (çift gönderim yok). Başarıda liste sunucudan tazelenir
 * (`INVALIDATION_MAP` `panelSales/statusChange`).
 */
export function* salesInquiriesSaga() {
  yield takeLatest(
    fetchSalesInquiries.request.type,
    apiSaga(fetchSalesInquiries, salesApi.fetchSalesInquiries),
  );
  yield takeLatest(
    fetchSalesCounts.request.type,
    apiSaga(fetchSalesCounts, salesApi.fetchSalesCounts),
  );
  yield takeLatest(
    fetchSalesInquiry.request.type,
    apiSaga(fetchSalesInquiry, (arg) => salesApi.fetchSalesInquiry(arg.id)),
  );
  yield takeLatest(
    fetchSalesInquiryPicker.request.type,
    apiSaga(fetchSalesInquiryPicker, salesApi.fetchSalesInquiries),
  );
  yield takeLatest(
    changeSalesInquiryStatus.request.type,
    apiSaga(changeSalesInquiryStatus, salesApi.changeSalesInquiryStatus, {
      onSuccess: function* () {
        yield* refreshSalesList();
        // Aramalı listede sayılar süzülüdür: rozet sayı ucundan tazelenir.
        yield put(fetchSalesCounts.request());
      },
      // Sonuç bilinmiyor: durum sunucuda değişmiş olabilir, detay + liste tazelenir.
      onFailure: function* (error, arg) {
        if (!isOutcomeUnknown(error)) return;
        yield put(fetchSalesInquiry.request({ id: arg.id }));
        yield* refreshSalesList();
        yield put(fetchSalesCounts.request());
      },
    }),
  );
}
